import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenBankingAccounts } from '@features/openBanking/hooks/useOpenBankingAccounts'

import { Scope } from '../../../../../../enums/scope'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { isAuthorized } from '../../../../../../utils/isAuthorized'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'
import { Widget } from '../../../../elements/Widget'
import {
  getActiveOpenBankingAccounts,
  getUnhealthyOpenBankingAccounts,
} from '../../utils/getUnhealthyOpenBankingAccounts'
import { BankConnectionNeedsAttention } from '../bankConnectionNeedsAttention/BankConnectionNeedsAttention'
import { BankDisconnection } from '../bankDisconnection/BankDisconnection'

export const CpaBankIntegration = (): ReactElement | null => {
  const { t } = useTranslation()
  const { openBankingAccounts, isLoading } = useOpenBankingAccounts()
  const { url: accountsUrl } = useOrganizationViewUrl(reactRoute.organization.bank.getBankAccountsRoute())

  if (isLoading) {
    return <Widget isLoading>{null}</Widget>
  }

  const hasConnectedAccounts = getActiveOpenBankingAccounts(openBankingAccounts).length > 0
  const unhealthyCount = getUnhealthyOpenBankingAccounts(openBankingAccounts).length

  if (!hasConnectedAccounts) {
    return isAuthorized(Scope.BankSyncWrite) ? (
      <Widget backgroundColor={colors.surface.highlight.beige.subtle.default}>
        <BankDisconnection isCpa />
      </Widget>
    ) : null
  }

  if (unhealthyCount === 0) {
    return null
  }

  return (
    <Widget title={t('dashboard.widget.bank-integration.title')}>
      <BankConnectionNeedsAttention count={unhealthyCount} accountsUrl={accountsUrl} />
    </Widget>
  )
}
